import React from "react";
import { ResetJti } from '../../actions/security-actions';
import { Claims } from '../../utils/services/cache/ClientCache'
import { getStudentNumberFromSession } from '../../utils/helpers/others/SessionHelper';

const ErrorFallback = ({ error }) => {
    const logout = async () => {
        ResetJti(getStudentNumberFromSession(), Claims.getJti());
        localStorage.clear()
        window.location.href = `${process.env.LOGOUT_URL}`;
    };

    return (
        <div className="notfoundContainer">
            <div className="notfound">
                <div className="notfound-404">
                    <h1>Oops!</h1>
                    <h2>Something went wrong</h2>
                </div>
                <a onClick={() => logout()}>GO TO LOGIN PAGE</a>
            </div>
        </div>
    );
};

export default ErrorFallback;